import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { hasPermission, hasAnyPermission } from '../utils/permissions';
import { getFirstAllowedPath } from '../utils/positionsApi';

const ProtectedRoute = ({ children, requireAdmin = false, requiredPermission, requiredPermissions }) => {
  const { isAuthenticated, user, isLoading } = useSelector(state => state.auth);
  const location = useLocation();

  // Show loading while authentication is being determined
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f8f9fa'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '40px',
          background: 'white',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid rgb(52, 152, 219)',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ color: '#666', margin: 0 }}>Verifying authentication...</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to={getFirstAllowedPath(user)} replace />;
  }

  if (requiredPermission && !hasPermission(user, requiredPermission)) {
    return <Navigate to={getFirstAllowedPath(user)} replace />;
  }
  if (requiredPermissions && requiredPermissions.length && !hasAnyPermission(user, requiredPermissions)) {
    return <Navigate to={getFirstAllowedPath(user)} replace />;
  }

  return children;
};

export default ProtectedRoute; 